export const ID = 'mobile-menu';
export const NAME = 'mobileMenu';
